import { MessageMedium } from 'constants/messageMediums';
import styled from 'styled-components';
import { Card } from 'ui/card';
import { colors, spacing, subtitle1, subtitle2 } from 'ui/theme';
import { CampaignTypeFilter } from 'modules/domains/campaign';
import {
  CAMPAIGN_TYPE_FILTER_CONTENT_MAPPER,
  MESSAGE_MEDIUM_CONTENT_MAPPER,
} from 'modules/campaigns/lib/utils';
import { CampaignTypeData } from '../constants';

export const Description = styled.div`
  ${subtitle2}
  margin-top: ${spacing.base};
  margin-bottom: ${spacing.half};
`;

export const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  padding: 0 ${spacing.base} ${spacing.base};
  border: ${spacing.single} solid ${colors.grey15};
  border-radius: ${spacing.half};
`;

export const Header = styled.div`
  display: flex;
  gap: ${spacing.quarter};
  align-items: center;
  ${subtitle1}
  padding: ${spacing.threeQuarter};
  margin: 0 -${spacing.base};
  border-bottom: ${spacing.single} solid ${colors.grey15};
`;

type Props = {
  campaignTypeData: CampaignTypeData;
  messageMedium: MessageMedium;
  children?: React.ReactNode;
};

/**
 * Renders blast, triggered, or eligibility campaign type cards
 * used in campaign alerts page
 */
export const CampaignTypeCard: React.FC<React.PropsWithChildren<Props>> = ({
  campaignTypeData,
  messageMedium,
  children,
  ...props
}: Props) => {
  const { type, displayName: campaignTypeDisplayName } = campaignTypeData;
  const { Icon: CampaignTypeIcon, displayName: campaignTypeTitle } =
    CAMPAIGN_TYPE_FILTER_CONTENT_MAPPER[type];
  const { displayName: messageMediumDisplayName } = MESSAGE_MEDIUM_CONTENT_MAPPER[messageMedium];

  return (
    <StyledCard data-test={`${messageMedium}-${type}-card`} {...props}>
      <Header>
        <CampaignTypeIcon color={colors.iconSubtle} />
        {campaignTypeTitle}
      </Header>
      <Description>{`Notify me when ${
        type === CampaignTypeFilter.Eligibility ? 'an' : 'a'
      } ${campaignTypeDisplayName} ${messageMediumDisplayName} campaign's...`}</Description>
      {children}
    </StyledCard>
  );
};
